export const TAX_FREE_NA_COUNTRY = 'es'
export const TAX_FREE_NA_LABEL = 'N/A'

export function resolveTaxFreeLabel ({
  country,
  taxFreeLabel,
}: {
  country?: string | null
  taxFreeLabel: string
}): string {
  if (country === TAX_FREE_NA_COUNTRY) {
    return TAX_FREE_NA_LABEL
  }

  return taxFreeLabel
}
